import React from 'react';
import PropTypes from 'prop-types';

import MojitoCore from 'mojito/core';

import {formatDateFromMask} from '#core/utils/date-utils.js';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const UIView = MojitoCore.Presentation.UIView;

// ///////////////////////////////////////////
// Implementation

class CurrentTimeImpl extends UIViewImplementation {
    /**
     * @constructs CurrentTime
     * @param {object} reactComponent The corresponding React component
     */
    constructor(reactComponent) {
        super(reactComponent);
    }

    setTime() {
        const {timeFormat} = this.style;
        const {timeOffset, includedTimeZone} = this.props;

        this.setState({
            time: formatDateFromMask(Date.now(), timeFormat, timeOffset, {withGMTTimezone: includedTimeZone}),
        });
    }

    componentDidMount() {
        this.setTime();
        this.handler = setInterval(() => this.setTime(), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.handler);
    }

    render() {
        return (
            <div className="current-time" style={this.style.containerStyle}>
                {this.renderLabel()}
                {this.renderTime()}
            </div>
        );
    }

    renderLabel() {
        if (!this.props.label) return null;

        return (
            <div className="current-time-label" style={this.style.labelStyle}>
                {this.props.label}
            </div>
        );
    }

    renderTime() {
        if (this.state && this.state.time) {
            return (
                <div className="current-time-value" style={this.style.timeStyle}>
                    {this.state.time}
                </div>
            );
        }

        return null;
    }
}

// ///////////////////////////////////////////
// Stylin

CurrentTimeImpl.getStyle = function (config, applicationMode, merge) {
    const style = {
        timeFormat: config.timeFormat || 'hh:mm:ss',
        timeStyle: merge({}, config.timeStyle),
        labelStyle: merge({}, config.labelStyle),
        containerStyle: merge(
            {
                display: 'flex',
                flexDirection: 'row',
            },
            config.containerStyle
        ),
    };

    return style;
};

CurrentTimeImpl.defaultProps = {
    label: '',
    timeOffset: 0,
    includedTimeZone: true,
};

const propTypes = {
    label: PropTypes.string,
    timeOffset: PropTypes.number,
    includedTimeZone: PropTypes.bool,
};

export const CurrentTime = UIView('CurrentTime', CurrentTimeImpl, propTypes, CurrentTimeImpl.defaultProps);
